import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltIconHelpCircleOutline } from '@cae/cobalt-react/icons/outline/CobaltIconHelpCircleOutline';
import { navigateToHelp } from '@shared/helpers/navigate-to-help/navigateToHelp';
import * as React from 'react';

import type { RegisterUserHelpBarProps } from './RegisterUserHelpBar.types';

import styles from './RegisterUserHelpBar.module.css';

const RegisterUserHelpBar = React.memo(
  ({
    emailExists,
  }: Readonly<RegisterUserHelpBarProps>): React.ReactElement | null => {
    const handleHelpClick = React.useCallback((): void => {
      navigateToHelp(true);
    }, []);

    if (emailExists) return null;

    return (
      <CobaltButton
        variant="ghost"
        className={styles.helpButton}
        onClick={handleHelpClick}
        aria-label="Help"
        data-testid="register-user-help-bar"
      >
        <CobaltIconHelpCircleOutline />
      </CobaltButton>
    );
  }
);

RegisterUserHelpBar.displayName = 'RegisterUserHelpBar';
export { RegisterUserHelpBar };
